<template>
    <section class="header-desktop" :key="keyRefresh">
      <div class="greyLayer" v-if="capaGris"></div>
      <div class="upperElements">
        <img border="0" alt="Eurocaja Rural" src="../assets/img/logoEurocaja.png">
        <!--<span class="filler"></span>-->
        <span class="app-tools">
          <button @blur="clickOutside">
            <div @click="toggle">
              <span class="icon">J
              </span>
              <span class="text">
                {{$locales.ajustes.ajustes}}
              </span>
            </div>
            <transition name="fade" appear>
              <div class="dropdown" v-if="active">
                <ul>
                  <li @click="toggle2">
                    {{$locales.ajustes.alertas.alertas}}<span class="arrow">&#9660;</span>
                  <span @click="refresh"><router-link to="/onesaitConfirmingProviders/ajustes/alertas/facturas"  class="link" v-if="active2">
                    {{$locales.ajustes.alertas.facturas}}
                  </router-link></span>
                </li>
                <li @click="toggle3">
                  {{$locales.ajustes.seguridadclaves.seguridadclaves}}<span class="arrow">&#9660;</span>
                  <span @click="refresh"><router-link to="/onesaitConfirmingProviders/ajustes/modificar-contrasena"  class="link" v-if="active3">
                  {{$locales.ajustes.seguridadclaves.modificarpassword}}
                  </router-link></span>
                  <span @click="refresh"><router-link to="/onesaitConfirmingProviders/ajustes/modificar-claveFirma"  class="link" v-if="active3">
                  {{$locales.ajustes.seguridadclaves.modificarclavefirma}}
                  </router-link></span>
                </li>
                <li @click="toggle4">
                  {{$locales.ajustes.datospersonales.datospersonales}}<span class="arrow">&#9660;</span>
                  <span @click="refresh"><router-link to="/onesaitConfirmingProviders/ajustes/datos-personales/modificar-datos"  class="link" v-if="active4">
                    {{$locales.ajustes.datospersonales.modificardatos}}
                  </router-link></span>
                </li>
                </ul>
              </div>
            </transition>
          </button>
          <router-link to="/onesaitConfirmingProviders/cambiar-cuenta"  class="link">
            <button @click="refresh">
            <span class="icon">N
            </span>
            <span class="text">
              {{$locales.cambiocuenta}}
            </span>
          </button>
          </router-link>
            <button @click="cerrarSesion">
              <span class="icon">T
              </span>
              <span class="text">
                {{$locales.salir}}
              </span>
            </button>
        </span>
      </div>
      <hr color = "#327e81" size="1">
      <div class="hiddenIcon">
        <button @blur="clickOutside">
          <p class="material-icons" @click="toggleMenu">menu</p>
          <transition name="menuLateral">
            <div class="dropleft" v-if="activeMenuLateral">
                <ul>
                  <li>
                    <p @click="toggleInicio" class="material-icons">home</p>
                    <div @click="toggleInicio" class="hiddenMenuText">
                      {{$locales.inicio}}
                    </div>
                    <p class="material-icons clear" @click="clickOutside">clear</p>
                  </li>
                  <li @click="toggleCondicionesEspeciales">
                    <p class="material-icons">account_balance_wallet</p>
                    <div class="hiddenMenuText">
                      {{$locales.condicionesespeciales.condicionesespeciales}}
                    </div>
                    <span class="arrow">&#9660;</span>
                  </li>
                  <li @click="toggleGestionAnticipos">
                    <p class="material-icons">playlist_add</p>
                    <div class="hiddenMenuText">
                      {{$locales.gestionanticipos.gestionanticipos}}
                    </div>
                  </li>
                  <li @click="toggleGestionPagos">
                    <p class="material-icons">card_travel</p>
                    <div class="hiddenMenuText">
                      {{$locales.gestionpagos}}
                    </div>
                  </li>
                  <li @click="toggleAjustes">
                    <p class="material-icons">settings</p>
                    <div class="hiddenMenuText">
                      {{$locales.ajustes.ajustes}}
                    </div>
                    <span class="arrow">&#9660;</span>
                  </li>
                  <li @click="toggleCambiarCuenta">
                    <p class="material-icons">supervisor_account</p>
                    <div class="hiddenMenuText">
                      {{$locales.cambiarcuenta}}
                    </div>
                  </li>
                </ul>
            </div>
          </transition>
          <transition name="menuMoreLateral">
            <div class="dropleftMore" v-if="activeCondicionesEspecialesLateral">
                <ul>
                  <li>
                    <div class="hiddenMenuText"></div>
                    <p class="material-icons clear" @click="cancelMoreMenu">clear</p>
                  </li>
                  <li>
                    <div class="hiddenMenuText">
                      {{$locales.condicionesespeciales.condicionesespeciales}}
                    </div>
                  </li>
                  <li @click="toggleCuentaAbono">
                    <div class="hiddenMenuText">
                      {{$locales.condicionesespeciales.cuentaabono}}
                    </div>
                  </li>
                  <li @click="toggleAnticipoAutomatico">
                    <div class="hiddenMenuText">
                      {{$locales.condicionesespeciales.anticipoautomatico}}
                    </div>
                  </li>
                </ul>
            </div>
          </transition>
          <transition name="menuMoreLateral">
            <div class="dropleftMore" v-if="activeAjustesLateral">
                <ul>
                  <li>
                    <div class="hiddenMenuText"></div>
                    <p class="material-icons clear" @click="cancelMoreMenu">clear</p>
                  </li>
                  <li>
                    <div class="hiddenMenuText">
                      {{$locales.ajustes.ajustes}}
                    </div>
                  </li>
                  <li @click="toggleMisAlertas"  id="desplegable">
                    <div class="hiddenMenuText">
                      <span>{{$locales.ajustes.alertas.alertas}}</span>
                      <span class="arrow">&#9660;</span>
                    </div>
                  </li>
                    <li v-if="activeMisAlertasLateral" @click="toggleMisFacturas">
                    <div class="hiddenMenuTextLink">
                        <span>{{$locales.ajustes.alertas.facturas}}</span>
                      </div>
                    </li>
                  <li @click="toggleSeguridadClaves" id="desplegable">
                    <div class="hiddenMenuText">
                      <span>{{$locales.ajustes.seguridadclaves.seguridadclaves}}</span>
                      <span class="arrow">&#9660;</span>
                    </div>
                  </li>
                    <li v-if="activeSeguridadClavesLateral" @click="toggleModificarContra">
                    <div class="hiddenMenuTextLink">
                        <span>{{$locales.ajustes.seguridadclaves.modificarpassword}}</span>
                      </div>
                    </li>
                    <li v-if="activeSeguridadClavesLateral" @click="toggleModificarClave">
                    <div class="hiddenMenuTextLink">
                        <span>{{$locales.ajustes.seguridadclaves.modificarclavefirma}}</span>
                      </div>
                    </li>
                  <li @click="toggleDatosPersonales"  id="desplegable">
                    <div class="hiddenMenuText">
                      <span>{{$locales.ajustes.datospersonales.datospersonales}}</span>
                      <span class="arrow">&#9660;</span>
                    </div>
                  </li>
                    <li v-if="activeDatosPersonalesLateral" @click="toggleModificarDatos">
                    <div class="hiddenMenuTextLink">
                        <span>{{$locales.ajustes.datospersonales.modificardatos}}</span>
                      </div>
                    </li>
                </ul>
            </div>
          </transition>
        </button>
        <p class="nombreVentana">{{ventana}}</p>
        <img border="0" alt="Eurocaja Rural" src="../assets/img/logoEurocaja.png">
        <button @blur="clickOutside">
          <p class="material-icons" @click="toggleMenuExit">more_vert</p>
          <transition name="menuSalir">
            <div class="dropExit" v-if="activeExit">
              <div class="buttonClear">
                <p class="material-icons clear" @click="clickOutside">clear</p>
              </div>
              <div class="buttonExit">   
                <p @click="cerrarSesion" class="icon">T</p>
                <p @click="cerrarSesion">{{$locales.salir}}</p>
              </div>
            </div>
          </transition>
        </button>
      </div>
      <nav class="topbar">
              <router-link to="/onesaitConfirmingProviders/home" class="link">
                <a @click="refresh" class="nav-item">{{$locales.inicio}}</a>
              </router-link>
              <router-link to="/onesaitConfirmingProviders/condiciones-especiales/cuenta-abono" class="link">
               <a @click="refresh" class="nav-item" >{{$locales.condicionesespeciales.condicionesespeciales}}</a>
              </router-link>
              <router-link to="/onesaitConfirmingProviders/gestion-anticipos" class="link">
                <a @click="refresh" class="nav-item">{{$locales.gestionanticipos.gestionanticipos}}</a>
              </router-link>
              <router-link to="/onesaitConfirmingProviders/ordenes-gestion-pagos/consulta" class="link">
                <a @click="refresh" class="nav-item">{{$locales.ordenesgestionpagos.ordenesgestionpagos}}</a>
              </router-link>
              <!--<router-link to="onesaitConfirmingProviders/componentes" class="link">
                <a class="nav-item">Componentes</a>
              </router-link> -->
      </nav>
      <router-view></router-view>
    </section>
</template>

<script>
export default {
    name : 'NavigationBarsComponent',
    data () {
      return {
        active: false,
        active2: false,
        active3: false,
        active4: false,
        activeMenuLateral: false,
        activeCondicionesEspecialesLateral: false,
        activeAjustesLateral: false,
        activeMisAlertasLateral: false,
        activeSeguridadClavesLateral: false,
        activeDatosPersonalesLateral: false,
        activeExit: false,
        capaGris : false,
        ventana : null,
        keyRefresh:0
      }
    },
    methods: {
      refresh(){ //esto tiene la funcion de refrescar el componente cuando volvemos a clickar sobre el en las NavigationBars
        this.keyRefresh+=1; //al cambiar la key de esta section que lo abarca todo, vue dispara un update
      },
      toggle () {
        this.active = !this.active
        if(this.active==false){
          this.active2 = false;
          this.active3 = false;
          this.active4 = false;
        }
      },
      toggle2 () {
        this.active2 = !this.active2
      },
      toggle3 () {
        this.active3 = !this.active3
      },
      toggle4 () {
        this.active4 = !this.active4
      },
      toggleInicio() {
        this.$router.push('/onesaitConfirmingProviders/home').catch(()=>{});
        this.refresh();
        this.capaGris = false;
        this.ventana = this.$locales.inicio;
        this.ocultarMenusLaterales();
      },
      toggleGestionAnticipos() {
        this.$router.push('/onesaitConfirmingProviders/gestion-anticipos').catch(()=>{});
        this.refresh();
        this.capaGris = false;
        this.ventana = this.$locales.gestionanticipos.gestionanticipos;
        this.ocultarMenusLaterales();
      },
      toggleGestionPagos() {
        this.$router.push('/onesaitConfirmingProviders/ordenes-gestion-pagos/consulta').catch(()=>{});
        this.refresh();
        this.capaGris = false;
        this.ventana = this.$locales.ordenesgestionpagos.consultaordenesgestionpagos;
        this.ocultarMenusLaterales();
      },
      toggleCuentaAbono() {
        this.$router.push('/onesaitConfirmingProviders/condiciones-especiales/cuenta-abono').catch(()=>{});
        this.refresh();
        this.capaGris = false;
        this.ventana = this.$locales.condicionesespeciales.cuentaabono;
        this.ocultarMenusLaterales();
      },
      toggleAnticipoAutomatico() {
        this.$router.push('/onesaitConfirmingProviders/condiciones-especiales/anticipo-automatico').catch(()=>{});
        this.refresh();
        this.capaGris = false;
        this.ventana = this.$locales.condicionesespeciales.anticipoautomatico;
        this.ocultarMenusLaterales();
      },
      toggleCambiarCuenta() {
        this.$router.push('/onesaitConfirmingProviders/cambiar-cuenta').catch(()=>{});
        this.refresh();
        this.capaGris = false;
        this.ventana = this.$locales.cambiocuenta;
        this.ocultarMenusLaterales();
      },
      toggleMisFacturas() {
        this.$router.push('/onesaitConfirmingProviders/ajustes/alertas/facturas').catch(()=>{});
        this.refresh();
        this.capaGris = false;
        this.ventana = this.$locales.ajustes.alertas.facturas;
        this.ocultarMenusLaterales();
      },
      toggleModificarContra() {
        this.$router.push('/onesaitConfirmingProviders/ajustes/modificar-contrasena').catch(()=>{});
        this.refresh();
        this.capaGris = false;
        this.ventana = this.$locales.ajustes.seguridadclaves.modificarpassword;
        this.ocultarMenusLaterales();
      },
      toggleModificarClave() {
        this.$router.push('/onesaitConfirmingProviders/ajustes/modificar-claveFirma').catch(()=>{});
        this.refresh();
        this.capaGris = false;
        this.ventana = this.$locales.ajustes.seguridadclaves.modificarclavefirma;
        this.ocultarMenusLaterales();
      },
      toggleModificarDatos() {
        this.$router.push('/onesaitConfirmingProviders/ajustes/datos-personales/modificar-datos').catch(()=>{});
        this.refresh();
        this.capaGris = false;
        this.ventana = this.$locales.ajustes.datospersonales.modificardatos;
        this.ocultarMenusLaterales();
      },
      toggleMisAlertas() {
        this.activeMisAlertasLateral = !this.activeMisAlertasLateral;
        this.activeSeguridadClavesLateral = false;
        this.activeDatosPersonalesLateral = false;
      },
      toggleSeguridadClaves() {
        this.activeSeguridadClavesLateral = !this.activeSeguridadClavesLateral;
        this.activeMisAlertasLateral = false;
        this.activeDatosPersonalesLateral = false;
      },
      toggleDatosPersonales() {
        this.activeDatosPersonalesLateral = !this.activeDatosPersonalesLateral;
        this.activeMisAlertasLateral = false;
        this.activeSeguridadClavesLateral = false;
      },
      toggleMenu () {
        this.activeMenuLateral = !this.activeMenuLateral;
        this.capaGris = !this.capaGris;
      },
      toggleCondicionesEspeciales () {
        this.activeCondicionesEspecialesLateral = !this.activeCondicionesEspecialesLateral;
        this.activeMisAlertasLateral = false;
        this.activeSeguridadClavesLateral = false;
        this.activeDatosPersonalesLateral = false;
        this.activeAjustesLateral = false;
      },
      toggleAjustes () {
        this.activeAjustesLateral = !this.activeAjustesLateral;
        this.activeMisAlertasLateral = false;
        this.activeSeguridadClavesLateral = false;
        this.activeDatosPersonalesLateral = false;
        this.activeCondicionesEspecialesLateral = false;
      },
      toggleMenuExit() {
        this.activeExit = !this.activeExit;
        this.capaGris = !this.capaGris;
      },
      clickOutside () {
        this.active = false;
        this.active2 = false;
        this.active3 = false;
        this.active4 = false;
        this.activeMenuLateral = false;
        this.activeCondicionesEspecialesLateral = false;
        this.activeAjustesLateral = false;
        this.activeMisAlertasLateral = false;
        this.activeSeguridadClavesLateral = false;
        this.activeDatosPersonalesLateral = false;
        this.activeExit = false;
        this.capaGris = false;
      },
      cancelMoreMenu () {
        this.activeCondicionesEspecialesLateral = false;
        this.activeAjustesLateral = false;
        this.activeMisAlertasLateral = false;
        this.activeSeguridadClavesLateral = false;
        this.activeDatosPersonalesLateral = false;
      },
      ocultarMenusLaterales() {
        this.activeMenuLateral = false;
        this.activeCondicionesEspecialesLateral = false;
        this.activeAjustesLateral = false;
        this.activeMisAlertasLateral = false;
        this.activeSeguridadClavesLateral = false;
        this.activeDatosPersonalesLateral = false;
      },
      cerrarSesion(){
        this.$cookies.keys().forEach(cookie => this.$cookies.remove(cookie)) //elimina todas las cookies
        this.$router.push('/identificacion'); //dirige a la pagina de login
      }
    }
}
</script>